import "./index.css";  

import { StyledEngineProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { persistor, store } from "@/redux/store";

import { App } from "./App";  

const queryClient = new QueryClient();

const container = document.getElementById("root");

const root = createRoot(container);

root.render(
    <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
            <Provider store={store}>
                <PersistGate
                    loading={null}
                    persistor={persistor}
                >
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                </PersistGate>
            </Provider>
        </StyledEngineProvider>
        <ReactQueryDevtools
            initialIsOpen={false}
            position="bottom"
        />
    </QueryClientProvider>,
);
